<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <div class="superadmin-dashboard-area edit-area">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="registered-product-item w-half">
                                <router-link :to="{name: 'CustomerRegisteredProducts'}" class="mb-3 inline-block"
                                    ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                                >
                                <h3 class="mb-4">Add product</h3>
                                <ul>
                                    <serial-and-model :data="form" />

                                    <li>
                                        <span class="semmibold">Date purchased:</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.date_of_purchase"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="purchased_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="purchaseDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semmibold">Installation date:</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.installation_date"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="install_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="installationDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="semmibold">Place of purchase:</span>
                                        <span><input type="text" v-model="form.place_of_purchase" /></span>
                                    </li>
                                    <li class="border-b-1">
                                        <file-uploader label="Upload proof of purchase" id="proof_of_purchase" :form.sync="form" />
                                    </li>
                                    <li>
                                        <span class="semmibold">Installation status</span>
                                        <span class="mt-1 coc-radio d-flex flex-column cursor-pointer">
                                            <label class="mr-2 font-normal" for="with_coc">
                                                <input
                                                    id="with_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="with_coc"
                                                />
                                                Installed with COC
                                            </label>
                                            <label class="mr-2 font-normal" for="without_coc">
                                                <input
                                                    id="without_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="without_coc"
                                                />
                                                Installation delayed
                                            </label>
                                            <label class="mr-2 font-normal" for="no_coc">
                                                <input
                                                    id="no_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="no_coc"
                                                />
                                                No COC
                                            </label>
                                        </span>
                                    </li>
                                    <ul v-show="form.installation_compliance == 'with_coc'">
                                        <li>
                                            <span class="semmibold">Coc number:</span> <span> <input type="text" v-model="form.coc_number" /></span>
                                        </li>
                                        <li class="border-bottom-input">
                                            <file-uploader label="Upload coc certificate" id="coc_certificate" :form.sync="form" />
                                        </li>
                                    </ul>

                                    <!-- <li>
                                        <span class="semmibold">invoice number:</span>
                                        <span> <input type="text" v-model="form.invoice_number" /></span>
                                    </li> -->
                                    <li class="mb-2">
                                        <span class="semmibold mb-2">Purchased from:</span>
                                        <div class="form-group form-radios-list mb-0">
                                            <label class="mr-2" for="reseller">
                                                <input
                                                    id="reseller"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.purchased_from_role"
                                                    value="reseller"
                                                />
                                                Reseller
                                            </label>
                                            &nbsp; &nbsp;
                                            <label class="mr-2" for="distributor">
                                                <input
                                                    id="distributor"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.purchased_from_role"
                                                    value="distributor"
                                                />
                                                Dewhot Service Centers / Website
                                            </label>
                                        </div>
                                    </li>
                                    <li v-if="form.purchased_from_role == 'reseller'">
                                        <span>
                                            <select v-model="form.purchased_from">
                                                <option value="">--- Select your reseller --</option>
                                                <option
                                                    :value="reseller.id"
                                                    v-bind:key="reseller.company + reseller.id"
                                                    v-for="reseller in resellerList"
                                                >
                                                    {{ reseller.company ? reseller.company : reseller.fname }}
                                                </option>
                                            </select>
                                        </span>
                                    </li>
                                    <li v-if="form.purchased_from_role == 'distributor'">
                                        <span>
                                            <select v-model="form.purchased_from">
                                                <option value="">--- Select your service center --</option>
                                                <option
                                                    :value="distributor.id"
                                                    v-bind:key="distributor.company + distributor.id"
                                                    v-for="distributor in distributorList"
                                                >
                                                    {{ distributor.company }}
                                                </option>
                                            </select>
                                        </span>
                                    </li>
                                </ul>
                                <button class="btn btn-primary mt-3" @click.prevent="registerProduct()">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import Helpers from '@/helpers/index';
import moment from 'moment';

export default {
    components: {},
    name: 'customerRegProductAdd',
    data() {
        return {
            seller: '',
            serial_number_max_length: 8,
            // sellerObj: {},
            showSuggest: true,
            sellerSuggestions: [
                {
                    data: []
                }
            ],
            distributorList: [],
            resellerList: [],
            form: {
                hasOrderNumber: false,
                product_model: '',
                serial_number: '',
                sku_number: '',
                order_number: '',
                sku_with_serial_number: '',
                place_of_purchase: '',
                date_of_purchase: '',
                installation_date: '',
                installation_compliance: 'with_coc',
                coc_number: '',
                coc_certificate: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                },
                invoice_number: '',
                purchased_from_role: 'reseller',
                purchased_from: '',

                proof_of_purchase: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                }
            }
        };
    },
    watch: {
        'form.purchased_from_role'() {
            this.form.purchased_from = '';
        }
        // 'form.date_of_purchase': {
        //     handler(newVal) {
        //         if (this.form.installation_date && newVal && this.form.installation_date < newVal) {
        //             this.form.installation_date = null;
        //         } else if (this.form.installation_date && !newVal) {
        //             this.form.installation_date = null;
        //         }
        //     },
        //     deep: true
        // },
        // 'form.installation_date': {
        //     handler(newVal) {
        //         if (this.form.date_of_purchase && newVal && this.form.date_of_purchase > newVal) {
        //             this.form.date_of_purchase = null;
        //         } else if (this.form.date_of_purchase && !newVal) {
        //             this.form.date_of_purchase = null;
        //         }
        //     },
        //     deep: true
        // }
    },

    computed: {
        purchaseDisabledDates() {
            let disabled = {from: new Date()};
            if (this.form.installation_date) {
                const dayAfterInstall = new Date(this.form.installation_date);
                dayAfterInstall.setDate(dayAfterInstall.getDate());
                disabled.from = dayAfterInstall;
            }
            return disabled;
        },
        installationDisabledDates() {
            let disabled = {from: new Date()};

            if (this.form.date_of_purchase) {
                const dayBeforePurchase = new Date(this.form.date_of_purchase);
                dayBeforePurchase.setDate(dayBeforePurchase.getDate());
                disabled.to = dayBeforePurchase;
            }

            return disabled;
        }
    },

    async mounted() {
        this.fetchDistributors();
        this.fetchResellers();
    },

    methods: {
        // fetch all distributors
        fetchDistributors() {
            const url = `${Env.baseUrl}/get-distributors?orderby=company`;
            AuthApis.getApi(url)
                .then((res) => {
                    this.distributorList = res.data.payload;
                })
                .catch((err) => {
                    this.distributorList = [];
                });
        },

        // fetch all distributors
        fetchResellers() {
            const url = `${Env.baseUrl}/get-resellers?orderby=company`;
            AuthApis.getApi(url)
                .then((res) => {
                    this.resellerList = res.data.payload;
                })
                .catch((err) => {
                    this.resellerList = [];
                });
        },

        /**
         * Register product */

        async registerProduct() {
            let validate = Helpers.validate(this.form, {
                product_model: 'required',
                serial_number: 'required',
                place_of_purchase: 'required',
                purchased_from: 'required'
            });
            if (!validate.status) {
                return this.$toasted.global.error({
                    message: validate.message
                });
            }

            this.form.sku_with_serial_number = Helpers.getFullSerialNumber(this.form);
            this.form.installation_date = this.form.installation_date ? moment(this.form.installation_date).format('YYYY-MM-DD') : '';
            this.form.date_of_purchase = this.form.date_of_purchase ? moment(this.form.date_of_purchase).format('YYYY-MM-DD') : '';

            if (this.form.date_of_purchase && this.form.installation_date && this.form.installation_date < this.form.date_of_purchase) {
                return this.$toasted.global.error({
                    message: 'Installation date cannot be before date of purchase.'
                });
            }

            let formData = new FormData();
            for (let key in this.form) {
                if (key != 'coc_certificate' && key != 'proof_of_purchase') {
                    formData.append(key, this.form[key]);
                }
            }

            if (this.form.coc_certificate.file) {
                formData.append('coc_certificate', this.form.coc_certificate.file);
            }

            if (this.form.proof_of_purchase.file) {
                formData.append('proof_of_purchase', this.form.proof_of_purchase.file);
            }

            this.$confirm({
                title: `WARNING: PLEASE CONFIRM`,
                html: `You will not be able to update or delete this record once you had added it:<br/>  Serial Number: <span>${this.form.sku_with_serial_number}</span><br/> Model: <span>${this.form.product_model}</span>`,
                button: {
                    no: 'CANCEL',
                    yes: 'PROCEED'
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.spinner(true);
                        const url = `${Env.baseUrl}/customer/reg-product/create`;
                        AuthApis.postApi(url, formData)
                            .then((res) => {
                                this.spinner(false);
                                this.$toasted.global.success({
                                    message: 'Successfully added.'
                                });
                                this.$router.push({name: 'CustomerRegisteredProducts'});
                            })
                            .catch((err) => {
                                this.spinner(false);
                                this.$toasted.global.error({
                                    message: err.response.data.errors[0]
                                });
                            });
                    }
                }
            });
        },

        /**
         *
         * On change serach reftch suggest
         */
        onChangeSellerInput: _.debounce(function (company) {
            // onChangeSellerInput: _debounce(company) {
            this.form.purchased_from = '';
            const url = `${Env.baseUrl}/customer/seller/suggest`;
            AuthApis.postApi(url, {
                name: company,
                role: this.form.purchased_from_role
            })
                .then((res) => {
                    this.sellerSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 500),

        /**
         * On click handle seller
         */
        selectSellerHandler(obj) {
            // this.sellerObj = obj.item;
            this.form.purchased_from = obj.item.id;
            // this.seller = obj.item.company ?  obj.item.company :  obj.item.email;
        },

        getSuggestionValue(obj) {
            return obj.item.company ? obj.item.company : obj.item.email;
        }
    }
};
</script>
